export default __webpack_public_path__ + "static/media/Billing Account.0ee15cb2.svg";